import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button, Card, Checkbox, Grid, ButtonGroup, ODataTable, Panel,
} from 'framework-ui-components';

import { InputRicerca, PageWrapper } from 'dashboard';
import PlusIcon from 'framework-ui-components/Components/Icons/PlusIcon';
import Servizi from 'enums/Servizi';
import ModaleSostituto from './ModaleSostituto';
import RigaServizioAttivo from './RigaSostituto';
import checkServizio from '../../helpers/checkServizio';

class ElencoSostituti extends Component {
    state = {
        searchTerm: '',
        mostraModaleSostituti: false,
        includiDisabilitati: false,
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.ufficioSelezionato.CodiceUfficio
            != nextProps.ufficioSelezionato.CodiceUfficio) {
            this.inputRicerca && this.inputRicerca.svuotaRicerca(false);
            this.setState({
                searchTerm: '',
            });
        }
    }

    onClickCerca = (searchTerm) => {
        this.setState({
            searchTerm: searchTerm.trim(),
        });
    }

    nuovoSostituto = () => {
        this.setState({
            mostraModaleSostituti: true,
        });
    }

    chiudiModaleSostituto = () => {
        this.setState({
            mostraModaleSostituti: false,
        });
        this.ricarica();
    }

    ricarica = () => {
        setTimeout(() => this.dataTable.loadPage(), 20);
    }

    render() {
        const {
            searchTerm,
            mostraModaleSostituti,
            includiDisabilitati,
        } = this.state;
        const {
            annoSelezionato,
            ufficioSelezionato,
            servizioAttivo,
            accessoNonConsentito
        } = this.props;

        return (
            <PageWrapper helmetTitle="730" pageTitle="Sostituti d'imposta">
                <Grid fluid className="pl-0 pr-0">
                    <Grid.Row>
                        <Grid.Col md="12">
                            <Card
                                title="Lista sostituti d'imposta"
                                multipleActions={
                                    servizioAttivo
                                    && (
                                        <ButtonGroup>
                                            <Button floating primary tooltip="Nuovo sostituto" onClick={this.nuovoSostituto}><PlusIcon /></Button>
                                        </ButtonGroup>
                                    )
                                }
                            >
                                <Grid.Row>
                                    <Grid.Col md="5">
                                        {!servizioAttivo && !accessoNonConsentito && <Panel error>Il servizio non è attivo. L'accesso è permesso solo in consultazione</Panel>}
                                        <InputRicerca
                                            onClickCerca={this.onClickCerca}
                                            ref={(r) => { this.inputRicerca = r; }}
                                        />
                                    </Grid.Col>
                                    <Grid.Col md="7" className="mt25">
                                        <Checkbox
                                            switch
                                            checked={includiDisabilitati}
                                            onChange={e => this.setState({
                                                includiDisabilitati: e.target.checked,
                                            })}
                                        />
                                        Mostra disabilitati
                                    </Grid.Col>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Col md="12">
                                        <ODataTable
                                            hover
                                            clickable
                                            url={`/api/V1/SostitutoImposta/CercaSostituti?searchTerm=${searchTerm}&ufficio=${ufficioSelezionato.CodiceUfficio}&includiDisabilitati=${includiDisabilitati}`}
                                            row={RigaServizioAttivo}
                                            ref={(r) => { this.dataTable = r; }}
                                            pageSize={10}
                                            availablePageSizes={[10, 20, 50]}
                                            additionalRowData={{
                                                searchTerm,
                                                ricarica: this.ricarica,
                                                ufficio: ufficioSelezionato.CodiceUfficio,
                                                anno: annoSelezionato,
                                            }}
                                        >
                                            <ODataTable.Column className="w-180">Codice Fiscale</ODataTable.Column>
                                            <ODataTable.Column>Cognome e Nome o Denominazione</ODataTable.Column>
                                            <ODataTable.Column>Codice Sede</ODataTable.Column>
                                            <ODataTable.Column>Telefono</ODataTable.Column>
                                            <ODataTable.Column>Fax</ODataTable.Column>
                                            <ODataTable.Column>E-mail</ODataTable.Column>
                                            <ODataTable.Column className="w-40"></ODataTable.Column>
                                        </ODataTable>
                                    </Grid.Col>
                                </Grid.Row>
                            </Card>
                        </Grid.Col>
                    </Grid.Row>

                    {mostraModaleSostituti
                        && (
                            <ModaleSostituto
                                ufficioSelezionato={ufficioSelezionato.CodiceUfficio}
                                idSostituto={-1}
                                showModal={mostraModaleSostituti}
                                onAnnulla={this.chiudiModaleSostituto}
                                annoSelezionato={annoSelezionato}
                            />
                        )
                    }
                </Grid>
            </PageWrapper>
        );
    }
}

const mapStoreToProps = store => ({
    ufficioSelezionato: store.utente.ufficioSelezionato,
    utente: store.utente.profilo,
    annoSelezionato: store.dichiarativi.annoSelezionato,
});

export default checkServizio(Servizi['7OL'])(connect(mapStoreToProps, null)(ElencoSostituti));
